<div class="home__herobanner__container" *ngIf="loading">
  <div class="placeholder">{{ 'home.banner.loading' | translate }}</div>
</div>

<div class="home__herobanner__container" *ngIf="!loading && error">
  <app-section-error [message]="error" (retry)="loadBanners()"></app-section-error>
</div>

<div class="home__herobanner__container" *ngIf="!loading && !error && (!images || !images.length)">
  <div class="placeholder">{{ 'home.banner.no_data' | translate }}</div>
</div>

<div class="home__herobanner__container" *ngIf="!loading && images && images.length">

  <div class="slides" [style.transform]="'translateX(-' + index * 100 + '%)'">
    <div class="slide" *ngFor="let img of images; let i = index">
      <picture>
        <source media="(max-width: 768px)" [srcset]="img.mobile">
        <img [src]="img.desktop" 
             [alt]="'home.banner.img_alt' | translate: { val: i + 1 }" 
             [title]="'home.banner.img_alt' | translate: { val: i + 1 }" />
      </picture>
    </div>
  </div>

  <div class="indicators" *ngIf="images.length > 1">
    <button
      class="indicator"
      *ngFor="let _ of images; let idx = index"
      [class.active]="idx === index"
      (click)="showSlide(idx)"
      [attr.aria-label]="'home.banner.go_to_slide' | translate: { val: idx + 1 }"
      [title]="'home.banner.go_to_slide' | translate: { val: idx + 1 }">
      <span class="visually-hidden">{{ 'home.banner.go_to_slide' | translate: { val: idx + 1 } }}</span>
    </button>
  </div>

  <button class="slide-btn prev" (click)="prevSlide()">
    <span class="material-icons">chevron_left</span>
  </button>
  <button class="slide-btn next" (click)="nextSlide()">
    <span class="material-icons">chevron_right</span>
  </button>
</div>